import { render, staticRenderFns } from "./OrganizationsRequestAcceptPage.vue?vue&type=template&id=6ea9a2de"
import script from "./OrganizationsRequestAcceptPage.vue?vue&type=script&lang=js"
export * from "./OrganizationsRequestAcceptPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports